import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChristmasService } from '../../services/christmas.service';

@Component({
  selector: 'app-snow-effect',
  templateUrl: './snow-effect.component.html',
  styleUrls: ['./snow-effect.component.css']
})
export class SnowEffectComponent implements OnInit, OnDestroy {
  snowflakes: Array<{ left: string; animationDelay: string; size: string; opacity: string }> = [];
  private maxFlakes = 30;
  isChristmasMode: boolean = false;

  constructor(private christmasService: ChristmasService) {}

  ngOnInit(): void {
    this.isChristmasMode = this.christmasService.isChristmasMode();
    if (this.isChristmasMode) {
      this.createSnowflakes();
    }
  }

  ngOnDestroy(): void {
  }

  private createSnowflakes(): void {
    for (let i = 0; i < this.maxFlakes; i++) {
      this.snowflakes.push({
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        size: `${Math.random() * 3 + 2}px`,
        opacity: `${Math.random() * 0.4 + 0.2}`
      });
    }
  }
}

